export default "__VITE_ASSET__rzl9ask8__"